import { render, staticRenderFns } from "./phase-assignment.vue?vue&type=template&id=a509c498&scoped=true&"
import script from "./phase-assignment.vue?vue&type=script&lang=ts&"
export * from "./phase-assignment.vue?vue&type=script&lang=ts&"
import style0 from "./phase-assignment.vue?vue&type=style&index=0&id=a509c498&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a509c498",
  null
  
)

export default component.exports